import { getApiUrl, tokenInterceptor, paramsSerializer } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const identificationStatsApi = createApi({
  reducerPath: 'identificationStatsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/stats'),
    prepareHeaders: tokenInterceptor,
    paramsSerializer,
  }),
  tagTypes: ['IdentificationStats'],
  endpoints: (builder) => ({
    studentIdentificationStats: builder.mutation({
      query: (obj) => ({
        url: `identification/student-identification`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['UsageStats'],
    }),
    levelOfImprovementObtainedStats: builder.mutation({
      query: (obj) => ({
        url: `identification/level-of-improvement`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['UsageStats'],
    }),
    centerClassesMap: builder.mutation({
      query: (obj) => ({
        url: `identification/center-classes`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['UsageStats'],
    }),
    publications: builder.mutation({
      query: (obj) => ({
        url: `identification/publications`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['UsageStats'],
    }),
    units: builder.mutation({
      query: (obj) => ({
        url: `identification/units`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
      }),
      providesTags: ['UsageStats'],
    }),
    downloadStudentIdentificationPdf: builder.mutation({
      query: (obj) => ({
        url: `identification/students-pdf`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
        responseHandler: (response) => response.blob(),
      }),
      providesTags: ['UsageStats'],
    }),
    downloadLevelOfImprovementPdf: builder.mutation({
      query: (obj) => ({
        url: `identification/level-of-improvement-pdf`,
        method: 'POST',
        body: {
          ...{ ...obj, countries: undefined },
          time_stamp: new Date().getTime(),
        },
        responseHandler: (response) => response.blob(),
      }),
      providesTags: ['UsageStats'],
    }),
  }),
});

export const {
  useStudentIdentificationStatsMutation,
  useLevelOfImprovementObtainedStatsMutation,
  useCenterClassesMapMutation,
  usePublicationsMutation,
  useUnitsMutation,
  useDownloadStudentIdentificationPdfMutation,
  useDownloadLevelOfImprovementPdfMutation,
} = identificationStatsApi;
